import { DownloadInfoItem } from '../types/analytics';
import { DTFullFormat } from './StaticVariable';

export function createDownloadOrderString(
  item: DownloadInfoItem,
  label: string,
  coords: number[],
  fileFormats: string,
  price: number
) {
  const shoppingCardDetails =
    item.datasetId +
    '&' +
    item.dateRange?.[0].format(DTFullFormat) +
    '&' +
    item.dateRange?.[1].format(DTFullFormat) +
    '&' +
    label +
    '&' +
    coords[0].toString() +
    ', ' +
    coords[1].toString() +
    '&' +
    'M' +
    '&' +
    fileFormats +
    '&' +
    '0' +
    '&' +
    price.toString() +
    '&';

  return shoppingCardDetails;
}
